import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac2002',
    ecrans: ['00-2'] 
});

